export const RTEClasses = 'ms-0.5 flex items-center p-1 rounded-sm transition hover:text-primary'
export const ActiveTextEditClasses =
  'focus:outline-none focus-visible:shadow-focus bg-tertiary-light/10 text-tertiary-light'
